import React from "react";
import Base from "../core/Base";
import LazyLoad from "react-lazyload";
import HeaderTitle from "../components/HeaderTitle";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const Gallery = () => {
  return (
    <Base>
      <HeaderTitle title="Our Gallery" />
      <section className="sarkarizone-images-area ptb-100">
        <h3 className="text-center pb-5 pt-5 gallery_text">Our Gallery</h3>
        <div className="container">
          <div className="row">
            <div className="row p-0 m-0">
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad once offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone1.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone2.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone3.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="row p-0 m-0">
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone4.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone5.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone6.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="row p-0 m-0">
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone7.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone8.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone9.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="row p-0 m-0">
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone10.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone11.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone12.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="row p-0 m-0">
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone13.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone14.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone15.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="row p-0 m-0">
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone16.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone17.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone18.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="row p-0 m-0">
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone19.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone20.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone21.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="row p-0 m-0">
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone22.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone23.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone24.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="row p-0 m-0">
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone25.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone26.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone27.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="row p-0 m-0">
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone28.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone29.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-blog">
                  <div className="blog-img">
                    <a href="#">
                      <LazyLoad offset={5}>
                        <img
                          src={require("../assets/img/gallery/sarkarizone30.jpg")}
                          alt="sarkarizone-images"
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Base>
  );
};

export default Gallery;
